import { useState, useEffect } from 'react';
const useIsMobile = function () {
  let mobileScreenSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1024;
  const [isMobile, setIsMobile] = useState(false);
  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    width < mobileScreenSize ? setIsMobile(true) : setIsMobile(false);
  }, [width]);
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);
  return {
    isMobile
  };
};
export default useIsMobile;